'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiBriefcase = function TiBriefcase(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 11.7c0-2.8-2.2-5-5-5h-10c-2.8 0-5 2.2-5 5-2.8 0-5 2.2-5 5v11.6c0 2.8 2.2 5 5 5h20c2.8 0 5-2.2 5-5v-11.6c0-2.8-2.2-5-5-5z m-15-1.7h10c0.9 0 1.7 0.7 1.7 1.7h-13.4c0-1 0.8-1.7 1.7-1.7z m16.7 18.3c0 1-0.8 1.7-1.7 1.7h-20c-0.9 0-1.7-0.7-1.7-1.7v-1.6h23.4v1.6z m-23.4-3.3v-8.3c0-0.9 0.8-1.7 1.7-1.7h20c0.9 0 1.7 0.7 1.7 1.7v8.3h-23.4z m13.4-5h-3.4c-0.9 0-1.6 0.8-1.6 1.7s0.7 1.6 1.6 1.6h3.4c0.9 0 1.6-0.7 1.6-1.6s-0.7-1.7-1.6-1.7z' })
        )
    );
};

exports.default = TiBriefcase;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/briefcase.js
// module id = 3561
// module chunks = 0